import { render } from "./PvInput.vue?vue&type=template&id=28d5e59a&scoped=true"
import script from "./PvInput.vue?vue&type=script&lang=js"
export * from "./PvInput.vue?vue&type=script&lang=js"

import "./PvInput.vue?vue&type=style&index=0&id=28d5e59a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d5e59a"]])

export default __exports__